import { useState } from 'react';
import options from '../../assets/currency.json';


const CurrencyDropDown = (props) => {

    var val = 'USD'
    if(props.defaultCurrency) {
        val = props.defaultCurrency
    }

    const [oldValue, setOldValue] = useState(val);

    const fnChange = (e) => {
        setOldValue(e.target.value);
        props.handleChange(e.target.value, oldValue);
    }

    return (
        <>
            <select  className="form-control country" defaultValue = {val}
            onChange={fnChange}>
                {options.map((item,key) => {
                        let name = item.name.slice(33);
                        return <option value={item.code} key={key}>{item.code}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{name}</option>
                })}
            </select>
        </>
    )
}

export default CurrencyDropDown;